export const drawerPaper = {
  width: { xs: "100%", md: "689px" },
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const drawerContainer = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const header = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  px: "24px",
  py: { xs: "12px", md: "24px" },
};

export const headerTitle = {
  fontSize: "18px",
  fontWeight: 500,
  lineHeight: "100%",
};

export const closeButton = {
  color: "rgba(62, 63, 76, 1)",
  fontSize: "20px",
};

export const tabsContainer = {
  borderBottom: 1,
  borderColor: "rgba(234, 234, 234, 1)",
  px: "24px",
  mb: "4px",
};

export const tabs = {
  minHeight: "auto",
  "& .MuiTabs-flexContainer": {
    gap: "24px",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "rgba(37, 124, 109, 1)",
    height: "2px",
  },
};

export const tab = {
  textTransform: "none",
  minWidth: "auto",
  px: "4px",
  py: "6px",
  minHeight: "22px",
  color: "rgba(62, 63, 76, 1)",
  fontSize: "15px",
  fontWeight: 500,
  "&.Mui-selected": {
    color: "rgba(37, 124, 109, 1)",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
  },
};

export const contentContainerWrapper = {
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  height: "100%",
};

export const contentContainer = {
  flex: 1,
  overflowY: "auto",
  flexBasis: 0,
  px: "24px",
  py: "24px",
};

export const profileSection = {
  display: "flex",
  alignItems: "flex-end",
  gap: "16px",
};

export const divider = {
  my: "24px",
  borderColor: "rgba(234, 234, 234, 1)",
};

export const formRow = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  gap: "24px",
  mb: "32px",
};

export const formField = {
  flex: 1,
};

export const phoneCodeSelectStyles = {
  m: "0px",
  minWidth: "82px",
  "& .MuiInputBase-input": {
    fontSize: "15px",
    color: "rgba(47, 43, 61, 0.9)",
    px: "12px",
    py: "8px",
  },
  "& fieldset": {
    borderRadius: "8px",
    borderColor: "rgba(230, 228, 235, 1)",
  },
  "&:hover .MuiInputBase-root fieldset": {
    borderColor: "rgba(36, 139, 112, 1)",
  },
  "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(36, 139, 112, 1)",
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgba(248, 247, 250, 1)",
    borderColor: "rgba(230, 228, 235, 1)",
    pointerEvents: "none",
    opacity: 0.5,
  },
  "& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(230, 228, 235, 1)",
  },
};

export const phoneCodeMenuItemStyles = {
  "&.Mui-selected": {
    color: "#fff",
    backgroundColor: "rgba(36, 139, 112, 1)",
  },
  "&.Mui-selected:hover": {
    backgroundColor: "rgba(36, 139, 112, 1)",
  },
};

export const checkboxContainer = {
  mb: 4,
};

export const deleteAccount = {
  textDecoration: "underline",
  fontSize: "15px",
  fontWeight: 400,
  color: "rgba(47, 43, 61, 0.9)",
  cursor: "pointer",
  display: "inline-block",
  mb: "20px",
};

export const footer = {
  mt: "4px",
  px: "24px",
  py: "16px",
  backgroundColor: "white",
  borderTop: "1px solid rgba(234, 234, 234, 1)",
  boxShadow: "0px -3px 8px 0px rgba(47, 43, 61, 0.08)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  zIndex: 1,
};

export const button = {
  textTransform: "none",
  color: "rgba(47, 43, 61, 0.7)",
  fontWeight: 500,
  fontSize: "15px",
  borderRadius: "8px",
  px: "12px",
  py: "6px",
  backgroundColor: "rgba(128, 131, 144, 0.16)",
  borderColor: "rgba(128, 131, 144, 0.16)",
  boxShadow: "none !important",
  "&:hover": {
    backgroundColor: "rgba(128, 131, 144, 0.24)",
  },
};

export const primaryButton = {
  ...button,
  color: "rgba(255, 255, 255, 1)",
  backgroundColor: "rgba(37, 124, 109, 1)",
  borderColor: "rgba(37, 124, 109, 1)",
  "&:hover": {
    backgroundColor: "rgba(37, 124, 109, 0.9)",
  },
  "&.Mui-disabled": {
    opacity: 0.8,
  },
};

export const ordersWrapper = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  px: "24px",
};

export const ordersTitle = {
  fontSize: "18px",
  fontWeight: 500,
  lineHeight: "28px",
  color: "rgba(72, 72, 72, 0.9)",
};
